/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AssetsObjectTypeSettingsEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const assetsObjectTypeSettingsEntryPoint: EntryPoint<
	AssetsObjectTypeSettingsEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<AssetsObjectTypeSettingsEntryPointComponent>(
		/* webpackChunkName: "async-assets-object-type-settings-entrypoint" */ './ConditionalRedirectOrRouteView.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
